import React, {useState} from 'react';

export default function InvoiceOrderDescription({value, onChange}) {
  const [open, setOpen] = useState(false);

  return <div>
    <textarea
      className="form-control"
      rows={2}
      style={{fontSize:12}}
      placeholder="Describe the order specifications"
      value={value || ''}
      onChange={event => onChange(event.target.value)}
    />
    <button
      type="button"
      className="btn btn-outline btn-sm"
      style={{marginTop:6}}
      onClick={() => setOpen(true)}
    >
      Describe order details
    </button>
    <div style={{fontSize:12, marginTop:6, color:'#3B2A21'}}>
      Record size, material, colours, handles, printing and special requirements.
      Production will see this description.
    </div>

    {open && <div className="modal-overlay" style={{zIndex:2000}}>
      <div className="modal" style={{maxWidth:650}}>
        <div className="modal-hdr">
          <span className="modal-title">Order Description</span>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => setOpen(false)}
          >Close</button>
        </div>

        <div className="modal-body">
          <p>
            Describe the customer's agreed order clearly. The Production Team
            Lead will compare this description with the job order.
          </p>
          <ul>
            <li>Product or bag style and quantity breakdown</li>
            <li>Finished dimensions, stating inches or centimetres</li>
            <li>Material, bag colour and gusset colour or fabric</li>
            <li>Handle type, colour and length where applicable</li>
            <li>Printing method, colour, wording, position and coverage</li>
            <li>Closures, bows, lining and other special requirements</li>
          </ul>
          <p>
            State “no printing” or “not applicable” where appropriate.
            Keep prices and payment terms in the invoice's financial fields.
          </p>
          <label className="form-label">Customer's order specifications</label>
          <textarea
            className="form-control"
            rows={10}
            value={value || ''}
            onChange={event => onChange(event.target.value)}
            placeholder="Example: Black jute tote, 10 inches wide × 12 inches high × 5 inches deep; rounded black handles; gold front print with names and date in white; print covers 45% of the front."
          />
        </div>

        <div className="modal-ftr">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setOpen(false)}
          >Use these details</button>
        </div>
      </div>
    </div>}
  </div>;
}
